import React from 'react'
import { Outlet, useMatches } from 'react-router-dom'
import { DEFAULT_ORDER_LIST_CONFIG, isOrderListRouteHandle, type OrderListConfig } from './orderListConfig'
import NewOrderButton from '../../components/NewOrderButton/NewOrderButton'

const Orders: React.FunctionComponent = () => {
    const activeOrderListHandle = useMatches()
        .map((match) => match.handle)
        .reverse()
        .find(isOrderListRouteHandle)

    const orderListConfig: OrderListConfig = activeOrderListHandle?.orderList ?? DEFAULT_ORDER_LIST_CONFIG
    return (
        <div>
            <div className='flex justify-between items-center my-2 flex-wrap gap-4 mb-4'>
                <h2>{orderListConfig.title}</h2>
                {orderListConfig.showCreateOrder && <NewOrderButton />}
            </div>
            <div className='flex flex-col shadow-sm space-y-4 bg-white border-full rounded-xl'>
                <Outlet context={orderListConfig} />
            </div>
        </div>
    )
}

export default Orders
